// Apolo IDE — ScheduleModal (Sprint v8.3 Hybrid agenda).
//
// Shell modal — abre fullscreen no mobile, dialog 3xl no desktop.
// Renderiza <SchedulesView /> que tem o layout Hybrid (D):
//   1. Timeline 24h HOJE com dots por command_type + now-line
//   2. Cards "Próximos 7 dias" coloridos por tipo
//   3. Pausadas collapsable archive
//
// Abrir via ⇧⌘T (useSessionShortcuts) ou sidebar Schedules.

import { lazy, Suspense } from 'react';
import { CalendarClock, X } from 'lucide-react';
import { useScheduledTasks } from '../hooks/useScheduledTasks.js';

// FASE-11 E5-WS4 — lazy: o modal só monta quando abre (⇧⌘T); o import estático
// puxava a SchedulesView (e a árvore dela) pro chunk de BOOT com o modal fechado.
const SchedulesView = lazy(() => import('./schedules/SchedulesView.jsx'));

export default function ScheduleModal({ open, onClose }) {
  // Conta tasks no header header (mesma fonte do hook que SchedulesView usa).
  const { tasks } = useScheduledTasks();

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="schedule-modal-title"
      className="fixed inset-0 z-50 flex items-stretch justify-stretch bg-black/70 lg:items-center lg:justify-center lg:p-4"
    >
      <div className="flex h-[100dvh] max-h-[100dvh] w-full max-w-full flex-col border-0 bg-apolo-surface1 shadow-2xl lg:h-full lg:max-h-[90vh] lg:max-w-3xl lg:rounded-apolo-2xl lg:border lg:border-apolo-borderSubtle">
        <header
          className="flex shrink-0 items-center gap-2 border-b border-apolo-borderSubtle p-4"
          style={{ paddingTop: 'max(1rem, env(safe-area-inset-top))' }}
        >
          <CalendarClock size={18} className="text-apolo-accent" aria-hidden="true" />
          <h2 id="schedule-modal-title" className="text-sm font-semibold text-apolo-textPrimary">
            Agenda
          </h2>
          <span className="text-xs text-apolo-textTertiary">
            {tasks.length} task{tasks.length === 1 ? '' : 's'}
          </span>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar"
            className="ml-auto inline-flex h-11 w-11 items-center justify-center rounded-apolo-md text-apolo-textTertiary transition hover:bg-apolo-surface2 hover:text-apolo-textPrimary focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accentRing lg:h-9 lg:w-9"
          >
            <X size={16} aria-hidden="true" />
          </button>
        </header>

        <div
          className="flex-1 overflow-auto p-4"
          style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom))' }}
        >
          <Suspense fallback={<div className="p-6 text-sm text-apolo-textTertiary">Carregando…</div>}>
            <SchedulesView />
          </Suspense>
        </div>
      </div>
    </div>
  );
}
